export const oauthProviders = ["google", "apple"] as const;

export type OAuthProvider = (typeof oauthProviders)[number];

export function oauthRedirectTo(origin: string, targetPath = "/app"): string {
  const normalizedOrigin = origin.replace(/\/+$/, "");
  const normalizedPath = targetPath.startsWith("/") ? targetPath : `/${targetPath}`;
  return `${normalizedOrigin}${normalizedPath}`;
}

export function magicLinkSignInOptions(origin: string, targetPath = "/app") {
  return {
    emailRedirectTo: oauthRedirectTo(origin, targetPath),
    shouldCreateUser: false
  };
}

export function supabaseAuthCallbackUrl(supabaseUrl: string): string {
  return `${supabaseUrl.replace(/\/+$/, "")}/auth/v1/callback`;
}

export function oauthProviderLabel(provider: OAuthProvider): string {
  return provider === "google" ? "Continue with Google" : "Continue with Apple";
}

export function oauthProviderSetupHint(provider: OAuthProvider): string {
  return provider === "google"
    ? "Requires Google provider credentials in Supabase Auth and the Supabase callback URI in Google Cloud."
    : "Requires Apple Services ID, redirect URI, and rotating client secret in Supabase Auth.";
}
